export const isNumber = n => !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
